import React, { Component } from "react";
import { Link } from "gatsby";

class ProjectTile extends Component {

    render() {
        return (
            <article className="item">
                <Link to={ this.props.page  } className="image fit" >
                    <img src={this.props.image} alt={this.props.image}  className="_thumb" />
                </Link>
                
                <header>
                    <h3>{this.props.title}</h3>
                </header>
                
            </article>
        );
    }
}

export default ProjectTile;